import { DeleteCategoryModal } from '@features/delete-category-modal/delete-category-modal';
import AddParticipantToCategoryModal from '@features/add-participant-to-category';
import { EditCategoryModal } from '@features/edit-category/edit-category-modal';
import { TrashIcon, PlusIcon, PencilSquareIcon } from '@shared/assets/icons';
import { AddParticipantsCBToCategoryModal } from '@entities/participants';
import { Category } from '@pages/event/api/useFetchCategory';
import { InvitedParticipants } from '@widgets/segments-tab';
import { IconButton } from '@shared/ui/icon-button';
import { CategoryLabel } from '@entities/category';
import * as stylex from '@stylexjs/stylex';
import { FC, memo, useState } from 'react';
import { Checkbox } from '@shared/ui/kit';
import { styles } from './styles';

interface SegmentCategoryHeaderProps {
  title: string;
  description?: string | null;
  countTicket: number;
  categoryId: number;
  refetch: () => void;
  eventId: number;
  participantsIds: number[];
  onSelectAll: (isSelected: boolean) => void;
  checked?: boolean;
  color?: string;
  invitedParticipants?: InvitedParticipants[];
  category?: Category;
  isCBGroup?: boolean;
}

export const SegmentCategoryHeader: FC<SegmentCategoryHeaderProps> = memo(
  ({
    title,
    description,
    countTicket,
    categoryId,
    refetch,
    eventId,
    participantsIds,
    onSelectAll,
    checked,
    color,
    invitedParticipants,
    category,
    isCBGroup = false,
  }) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isAddParticipant, setIsAddParticipant] = useState(false);

    const handleEditClick = () => {
      setIsEditModalOpen(true);
    };

    const handleDeleteClick = () => {
      setIsDeleteModalOpen(true);
    };

    const handleAddParticipantClick = () => {
      setIsAddParticipant(true);
    };

    const handleCloseModal = () => {
      setIsEditModalOpen(false);
    };

    const handleCloseDeleteModal = () => {
      setIsDeleteModalOpen(false);
    };

    const handleCheckboxChange = () => {
      onSelectAll(!checked);
    };
    return (
      <>
        <div {...stylex.props(styles.container)}>
          <div {...stylex.props(styles.body)}>
            <Checkbox isChecked={checked} onChange={handleCheckboxChange} />
            <CategoryLabel name={title} color={color} />
            <p {...stylex.props(styles.quantity)}>участников: {countTicket}</p>
          </div>

          <div {...stylex.props(styles.actions)}>
            <div {...stylex.props(styles.iconContainer)}>
              <IconButton icon={<TrashIcon color="currentColor" />} onClick={handleDeleteClick} />
            </div>

            <div {...stylex.props(styles.iconContainer)}>
              <IconButton icon={<PencilSquareIcon color="currentColor" />} onClick={handleEditClick} />
            </div>

            <div {...stylex.props(styles.iconContainer)}>
              <IconButton icon={<PlusIcon color="currentColor" />} onClick={handleAddParticipantClick} />
            </div>
          </div>
        </div>

        <AddParticipantToCategoryModal
          isOpen={!isCBGroup && isAddParticipant}
          onClose={() => setIsAddParticipant(false)}
          categoryId={categoryId}
          refetch={() => {
            refetch();
          }}
          title={title}
          eventId={eventId}
          participantsIds={participantsIds}
          invitedParticipants={invitedParticipants}
        />

        <EditCategoryModal
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          countTicket={countTicket}
          categoryId={categoryId}
          initialTitle={title}
          initialDescription={description || ''}
          eventId={eventId}
          initialColor={color}
        />

        <DeleteCategoryModal
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModal}
          categoryId={categoryId}
          refetch={refetch}
          countTicket={countTicket}
          title={title}
        />

        <AddParticipantsCBToCategoryModal
          isOpen={isCBGroup && isAddParticipant}
          onClose={() => setIsAddParticipant(false)}
          refetchParticipants={refetch}
          invitedParticipants={invitedParticipants}
          category={category}
        />
      </>
    );
  }
);
